export const CELL_PADDING = 3
export const CELL_MIN_WIDTH = 220
